import { usePersonDialog } from 'features/user/hooks/usePersonDialog';
import React, { useEffect, useState } from 'react';
import {
  Card,
  Fade,
  Grid,
  List,
  ListItem,
  Typography,
  makeStyles,
  Fab,
  Tooltip,
  Badge,
} from '@material-ui/core';
import PlusCircleButton from 'components/RMSButtons/RMSAddButton/plusCircleButton';
import ArrowDropDownCircleIcon from '@material-ui/icons/ArrowDropDownCircle';
import PersonIcon from '@material-ui/icons/Person';
import { alpha } from '@mui/material';
import { getService } from 'reducers/service';
import { connect, useSelector, useDispatch } from 'react-redux';
import RMSDeleteButton from 'components/RMSButtons/RMSDeleteButton';
import { showEditWarrantParty } from 'reducers/PersonDialogsReducer';
import { hideSpinner, showSpinner } from 'reducers/UiReducer';
import { notify } from 'reducers/NotifierReducer';
import { handleError } from 'reducers/ErrorReducer';
import EditIcon from '@material-ui/icons/Edit';
import { UrgentMessageIcon } from '../../../features/shared/utility/UrgentMessageHelper';

const PRIMARY_COLOR = '#1977D4';
const useStyles = makeStyles((theme) => ({
  cardView: {
    paddingTop: 0,
    backgroundColor: theme.accordion.background,
    color: 'inherit',
    width: '100%',
    borderRadius: '5px',
  },
  spanHeader: {
    color: theme.palette.colors.label,
    fontWeight: 'bold',
    backgroundColor: theme.palette.customBg,
    width: '100%',
    padding: '3px',
    paddingLeft: '15px',
    borderRadius: '5px',
    // paddingTop: '5px',
  },
  svg_icons: {
    paddingLeft: '5x',
    color: PRIMARY_COLOR,
  },
  svg_icons_rotated: {
    paddingLeft: '5x',
    transform: 'rotate(180deg)',
    color: PRIMARY_COLOR,
  },
  list_div: {
    border: `2px solid #B5B5B5`,
    borderColor: theme.palette.type === 'dark' ? '#7C7C7C' : '#B5B5B5',
    borderRadius: '10px',
    width: '100%',
    marginLeft: '28px',
  },
  listHeader: {
    background: alpha('#1976d2', 0.2),
    color: theme.palette.colorFont,
    borderRadius: '5px',
    paddingTop: '2px',
    paddingRight: '8px',
    height: '30px',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  parent_div: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  default_div: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  list_root: {
    width: '100%',
    paddingTop: '2px',
    // paddingLeft: '30px',
    overflowY: 'scroll',
  },
  listItem_root: {
    padding: '0px',
  },
  listItem: {
    borderTop: '.5px solid ',
    borderColor: theme.palette.type === 'light' ? '#d0d0d0' : '#616161',
    '&:hover': {
      backgroundColor: alpha('#1976d2', 0.2),
    },
  },
  fabStyle: {
    backgroundColor: theme.palette.colors.chipBg,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  badgeDot: {
    width: '14px',
    height: '14px',
    minWidth: '14px',
    borderRadius: '50%',
    padding: 0,
  },
}));

function PartiesWarrant(props) {
  const { ptsWarrantID } = props;
  const service = getService('rms-warrant');
  const classes = useStyles();
  const [cardExpanded, setCardExpanded] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const [rows, setRows] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [cardHeight, setCardHeight] = useState(0);
  const [selected, setSelected] = useState({});
  const [isDeleted, setIsDeleted] = useState(false);
  const dispatch = useDispatch();
  const { openPersonDialog } = usePersonDialog();
  const dataUpdate = useSelector((state) => state.dataUpdate);

  const processData = (data) => {
    return data.map((row, idx) => {
      return {
        ...row,
        id: idx + 1,
      };
    });
  };
  useEffect(() => {
    if ((dataUpdate && dataUpdate.type === 'warrants-parties') || initialLoad) {
      getData();
    }
    setInitialLoad(false);
    // eslint-disable-next-line
  }, [dataUpdate]);

  const getData = async () => {
    const res = await service.find({
      query: { type: 'warrant_party', data: { ptsWarrantID: ptsWarrantID } },
    });
    setRows(processData(res));
    setLoaded(true);
  };

  useEffect(() => {
    if (rows.length > 0) {
      if (cardExpanded) {
        setCardHeight(45 * rows.length + 8 + 'px');
      } else {
        setCardHeight('90px');
      }
    }
  }, [cardExpanded, rows]);

  const generateHeaderRow = () => {
    return (
      <Grid container item lg={12} xs={12} className={classes.listHeader}>
        <Grid container item xs={10}>
          <Grid item xs={1}></Grid>
          <Grid item xs={3}>
            Party Type
          </Grid>
          <Grid item xs={4}>
            Party Parent Type
          </Grid>
          <Grid item xs={4}>
            Party Name
          </Grid>
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
    );
  };

  const generateListItem = (it) => {
    return (
      <Grid container item xs={10} className="items-center">
        <Grid item xs={1}></Grid>
        <Grid container item xs={3} className={classes.parent_div}>
          <div className={classes.default_div}>{it.PartyType}</div>
        </Grid>
        <Grid container item xs={4} className={classes.parent_div}>
          <div className={classes.default_div}>{it.PartyParentType || ''}</div>
        </Grid>
        <Grid container item xs={4} className={classes.parent_div}>
          <div className={classes.default_div}>
            {UrgentMessageIcon(it)} {it.FullName || ''}
          </div>
        </Grid>
      </Grid>
    );
  };

  const onAdd = () => {
    props.showEditWarrantParty({ ptsWarrantID });
  };

  const onEdit = (row) => {
    if (!row) return;
    props.showEditWarrantParty({
      isEdit: true,
      ROWGUID: row.ROWGUID,
      ptsWarrantID,
      ptsPartyID: row.ptsPartyID,
      WarrantPartyType: row.WarrantPartyType,
      WarrantPartyTypeDescription: row.PartyType,
      PartyParentType: row.PartyParentType,
      FullName: row.FullName,
    });
  };

  const onDelete = async (row) => {
    try {
      props.showSpinner();

      await service
        .patch(null, {
          type: 'remove_warrant_party',
          data: {
            ptsWarrantID,
            ptsPartyID: row?.ptsPartyID,
            WarrantPartyType: row?.WarrantPartyType,
          },
        })
        .then((res) => {
          getData();
          setIsDeleted(!isDeleted);
        });
      // props.notifyDataUpdate({ type: 'Warrant Offenses' });
    } catch (err) {
      props.handleError(err);
    } finally {
      props.hideSpinner();
    }
  };

  const personButton = (row) => (
    <Fab
      size="small"
      color="secondary"
      aria-label="edit"
      onClick={() => openPersonDialog(row.ptsPersonID)}
      className={classes.fabStyle}
      style={{ width: '40px', height: '40px' }}>
      <PersonIcon />
    </Fab>
  );

  return (
    <Card className={classes.cardView}>
      <Grid container spacing={1}>
        <Grid item container style={{ marginLeft: '10px', marginBottom: '3px' }} xs={12}>
          <Grid item xs={12} style={{ marginTop: '6px', display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: '5px' }}></span>
            <PersonIcon style={{ color: PRIMARY_COLOR }} />
            <Typography variant="span" className={classes.spanHeader}>
              Parties {rows.length > 0 ? `(${rows.length})` : ''}
            </Typography>
            <span
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                paddingRight: '20px',
                paddingBottom: '3px',
                paddingTop: '3px',
              }}>
              <span
                style={{
                  padding: '0px',
                  '&:hover': {
                    background: 'transparent',
                  },
                  border: 'none',
                  background: 'transparent',
                  marginLeft: '-7px',
                }}>
                <PlusCircleButton disabled={props.viewOnly} onClick={() => onAdd()} />
              </span>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ArrowDropDownCircleIcon
                  onClick={() => setCardExpanded(!cardExpanded)}
                  className={cardExpanded ? classes.svg_icons_rotated : classes.svg_icons}
                  style={{
                    marginLeft: '10px',
                  }}
                />
              </div>
            </span>
          </Grid>
          {rows.length > 0 && (
            <Grid container item xs={12} className={classes.list_div}>
              {generateHeaderRow()}
              <List className={classes.list_root} style={{ height: cardHeight }}>
                {rows.map((it, index) => {
                  return (
                    <ListItem className={classes.listItem_root}>
                      <Grid
                        item
                        container
                        xs={12}
                        style={{ borderWidth: index === 0 ? '0' : '' }}
                        className={classes.listItem}
                        onMouseEnter={(event) => setSelected(it)}
                        onMouseLeave={() => setSelected({})}>
                        {generateListItem(it)}
                        <Grid
                          item
                          xs={2}
                          style={{
                            paddingTop: '0px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}>
                          <Fade in={selected.id === it.id}>
                            <Grid container wrap="nowrap" spacing={2} justify="flex-end" xs={12}>
                              <Grid
                                item
                                justify="flex-end"
                                style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Tooltip title="Person Record">
                                  {it.hasAnyUrgentMessage ? (
                                    <Badge
                                      color="error"
                                      variant="dot"
                                      overlap="circular"
                                      classes={{ dot: classes.badgeDot }}>
                                      {personButton(it)}
                                    </Badge>
                                  ) : (
                                    personButton(it)
                                  )}
                                </Tooltip>

                                <Grid item justify="flex-end">
                                  <Fab
                                    size="small"
                                    className={classes.fabStyle}
                                    disabled={props.viewOnly}
                                    onClick={() => onEdit(it)}>
                                    <EditIcon />
                                  </Fab>
                                </Grid>
                                <RMSDeleteButton
                                  disabled={props.viewOnly}
                                  className={classes.fabStyle}
                                  onClick={() => onDelete(it)}
                                  entityName={'Offense'}
                                />
                              </Grid>
                            </Grid>
                          </Fade>
                        </Grid>
                      </Grid>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Card>
  );
}

export default connect(null, {
  showEditWarrantParty,
  showSpinner,
  hideSpinner,
  notify,
  handleError,
})(PartiesWarrant);
